module.exports = __webpack_public_path__ + "static/media/good_job_you_are_a_cavity_monster_hero.ae491b4.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/good_job_you_are_a_cavity_monster_hero.mp3
// module id = Ztez
// module chunks = 0